const appDetails = {
	webLink: "",
	googlePlayLink: "",
	appStoreLink: "",
	landingPage: "cashbids",
	signUpButton: true
};

export default appDetails;
